import React from 'react';
import { luxColors, DNABox, DNAText, DNAButton } from '@alucio/lux-ui';
import { StyleSheet } from 'react-native';
const styles = StyleSheet.create({
    attendeeDisconnected: {
        color: luxColors.info.primary,
        marginBottom: 15,
        maxWidth: 114,
        textAlign: 'center',
        fontWeight: '500',
        fontStyle: 'normal',
        lineHeight: 16,
    },
    roomFullLabel: {
        color: luxColors.info.primary,
        marginBottom: 15,
    },
});
export const AdmitDenyContent = (props) => {
    return (React.createElement(DNABox, { spacing: "small" },
        React.createElement(DNAButton, { testID: "accept-attendee", size: "tiny", onPress: props.onAccept, status: "success" }, "Admit"),
        React.createElement(DNAButton, { size: "tiny", onPress: props.onDeny, status: "danger" }, "Decline")));
};
export const DeclineContent = (props) => {
    return (React.createElement(DNABox, { appearance: "col", alignX: "center", alignY: "center" },
        React.createElement(DNAText, { style: styles.roomFullLabel, h5: true }, "Room is full"),
        React.createElement(DNAButton, { size: "tiny", onPress: props.onDeny, status: "danger" }, "Decline")));
};
export const DeclineContentSmall = (props) => {
    return (React.createElement(DNABox, { appearance: "col", alignX: "center", alignY: "center" },
        React.createElement(DNAText, { h5: true }, "Room is full"),
        React.createElement(DNAButton, { size: "tiny", onPress: props.onDeny, style: { width: 8 }, status: "danger", iconLeft: "close" })));
};
export const AdmitDenyContentSmall = (props) => {
    return (React.createElement(DNABox, { spacing: "small" },
        React.createElement(DNAButton, { testID: "accept-attendee", size: "tiny", style: { width: 8 }, onPress: props.onAccept, status: "success", iconLeft: "check" }),
        React.createElement(DNAButton, { size: "tiny", onPress: props.onDeny, style: { width: 8 }, status: "danger", iconLeft: "close" })));
};
export const DiscconnectedContent = (props) => {
    return (React.createElement(DNABox, { appearance: "col", alignX: "center", alignY: "center" },
        React.createElement(DNABox, { appearance: "row" },
            React.createElement(DNAText, { style: styles.attendeeDisconnected, numberOfLines: 1 },
                " ",
                `${props.name}`),
            React.createElement(DNAText, { style: [styles.attendeeDisconnected, { marginLeft: 5 }], h5: true, numberOfLines: 1 }, ' has left.')),
        React.createElement(DNAButton, { size: "tiny", onPress: props.onDeny, status: "success" }, "Ok")));
};
export const DiscconnectedContentSmall = (props) => {
    return (React.createElement(DNABox, { appearance: "col", alignX: "center", alignY: "center" },
        React.createElement(DNABox, { appearance: "row" },
            React.createElement(DNAText, { style: [styles.attendeeDisconnected, { marginBottom: 4 }], numberOfLines: 1 },
                " ",
                `${props.name}`),
            React.createElement(DNAText, { style: [styles.attendeeDisconnected, { marginLeft: 5, marginBottom: 4 }], h5: true, numberOfLines: 1 }, ' left.')),
        React.createElement(DNAButton, { size: "tiny", onPress: props.onDeny, iconLeft: "check", status: "success" })));
};
//# sourceMappingURL=AcceptDeny.js.map